import { Accordion } from '@mantine/core';
import { IconBell } from '@tabler/icons-react';
import NotificationSettings from './NotificationSettings';
import type { SuiteForm } from './form';
import type { NotificationProfile } from '@prisma/client';

export function NotificationsSection({
  form,
  projectId,
  testSuiteId,
  notificationProfile,
  hideChannelConfiguration,
}: {
  form: SuiteForm;
  projectId: string;
  testSuiteId: string;
  notificationProfile: NotificationProfile;
  hideChannelConfiguration?: boolean;
}) {
  return (
    <Accordion.Item value="notifications">
      <Accordion.Control icon={<IconBell size={14} />}>Notifications</Accordion.Control>
      <Accordion.Panel>
        <NotificationSettings
          projectId={projectId}
          testSuiteId={testSuiteId}
          selectedProfile={notificationProfile}
          onProfileChange={(profile) => form.setFieldValue('notificationProfile', profile)}
          hideChannelConfiguration={hideChannelConfiguration}
        />
      </Accordion.Panel>
    </Accordion.Item>
  );
}
